import {Icon, Icons} from './icon';

export class Circle {
  x: number;
  y: number;
  deg?: number;
  constructor(data: Circle) {
    this.x = data.x || 0;
    this.y = data.y || 0;
    this.deg = data.deg || 0;
  }
}

export class Continent {
  x: number;
  y: number;
  xb?: number;
  yb?: number;
  title?: string[];
  id?: number;
  icon?: Icon;
  iconA?: Icon;
  url?: string;
  isHovered?: boolean;

  constructor(data: Continent) {
    this.x = data.x || 0;
    this.y = data.y || 0;
    this.xb = data.xb || 0;
    this.yb = data.yb || 0;
    this.title = data.title || [];
    this.id = data.id || 0;
    this.icon = data.icon || Icons.default;
    this.iconA = data.iconA || Icons.default;
    this.url = data.url ?? '';
    this.isHovered = data.isHovered ?? false;
  }
}
export const ContinentUrls = [
  'antarctica',
  'asia',
  'australia-and-oceania',
  'africa',
  'europe',
  'middle-east',
  'north-america',
];
export const ContinentIcons = [
  Icons.antarctica, Icons.africa, Icons.asia, Icons.australia, Icons.europe, Icons.middleEast, Icons.northAmerica, Icons.southAmerica
];

export const ContinentTitles = [
  ['Антарктида', 'Antarctica'],
  ['Азия', 'Asia'],
  ['Австралия & Океания', 'Australia & Oceania'],
  ['Африка', 'Africa'],
  ['Европа', 'Europe'],
  ['Ближний Восток', 'Middle East'],
  ['Северная Америка', 'North America'],
];
